import React from 'react'
import { Row, Col } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

const ColView = ({ title, value }) => (
  <Col xs='12'>
    <strong>{I18n.t(title)}:</strong> {value || ''}
  </Col>
)

const AddressView = ({ address, onClick }) => {
  if (!address) return <div>{I18n.t('dashboard_no-results-found')}</div>

  return (
    <Row className='plugin-card' onClick={onClick}>
      <ColView title='dashboard_street' value={address.street || ''} />
      <ColView title='dashboard_city' value={address.city || ''} />
      <ColView title='dashboard_postal-code' value={address.postcode|| ''} />
      <ColView title='dashboard_province' value={address.province || ''} />
      <ColView title='dashboard_country' value={address.country || ''} />
      <ColView title='dashboard_email' value={address.email || ''} />
      <ColView title='dashboard_phone' value={`${address.dialCode || ''}${address.telephone || ''}`} />
    </Row>
  )
}

export default AddressView
